import type { Messages } from '../i18n.types'

/** Hungarian admin UI strings (ADR-043). */
export const hu: Messages = {
  common: {
    breadcrumb: 'Morzsamenü',
    loading: 'Betöltés',
    somethingWrong: 'Hiba történt',
    reference: 'Hivatkozás: {id}',
    dismiss: 'Bezárás',
    close: 'Bezárás',
    cancel: 'Mégse',
    confirm: 'Megerősítés',
    delete: 'Törlés',
    remove: 'Eltávolítás',
    save: 'Mentés',
    saving: 'Mentés…',
    create: 'Létrehozás',
    edit: 'Szerkesztés',
    search: 'Keresés',
    type: 'Típus',
    status: 'Állapot',
    all: 'Mind',
    yes: 'Igen',
    no: 'Nem',
    untitled: 'Cím nélkül',
    previous: 'Előző',
    next: 'Következő',
    total: 'Összesen {count}',
    range: '{from}–{to} / {total}',
    selected: '{count} kijelölve',
    selectItem: '{name} kijelölése',
    name: 'Név',
    key: 'Kulcs',
    description: 'Leírás',
    actions: 'Műveletek',
    updated: 'Módosítva',
    created: 'Létrehozva',
    version: 'Verzió',
    language: 'Nyelv',
    languages: 'Nyelvek',
    allLanguages: 'Minden nyelv',
    refresh: 'Frissítés',
    back: 'Vissza',
    open: 'Megnyitás',
    none: 'Nincs',
    email: 'E-mail',
    password: 'Jelszó',
    displayName: 'Megjelenített név',
    enabled: 'Engedélyezve',
    disabled: 'Letiltva',
    details: 'Részletek',
    filter: 'Szűrő',
    clear: 'Törlés',
    view: 'Megtekintés',
  },
  list: {
    any: 'Bármelyik',
    filters: 'Szűrők',
    results: '{count} találat',
    resultOne: '1 találat',
    clear: 'Szűrők törlése',
    removeFilter: 'Szűrő eltávolítása: {name}',
    since: '{day} óta',
    until: '{day}-ig',
    min: 'Min.',
    max: 'Max.',
    from: 'Ettől',
    to: 'Eddig',
    range: '{first}–{last} / {total}',
    perPage: 'Oldalanként',
    pages: 'Oldalak',
    noneMatch: 'Semmi sem felel meg a szűrőknek',
    noneMatchHelp: 'Módosítsa vagy törölje a szűrőket, hogy többet lásson.',
  },
  nav: {
    dashboard: 'Áttekintés',
    content: 'Tartalom',
    media: 'Média',
    contentTypes: 'Tartalomtípusok',
    plugins: 'Bővítmények',
    users: 'Felhasználók',
    roles: 'Szerepkörök',
    audit: 'Naplózás',
    groupContent: 'Tartalom',
    groupBuild: 'Felépítés',
    groupAdmin: 'Adminisztráció',
    mail: 'E-mail',
    backup: 'Biztonsági mentés',
    website: 'Weboldal',
  },
  crumbs: {
    content: 'Tartalom',
    newEntry: 'Új bejegyzés',
    edit: 'Szerkesztés',
    contentTypes: 'Tartalomtípusok',
    builder: 'Szerkesztő',
    media: 'Média',
    users: 'Felhasználók',
    roles: 'Szerepkörök',
    plugins: 'Bővítmények',
    details: 'Részletek',
    extension: 'Bővítés',
    audit: 'Naplózás',
    settings: 'Beállítások',
    mail: 'E-mail',
    backup: 'Biztonsági mentés',
    website: 'Weboldal',
  },
  // English until translated.
  mail: {
    kicker: 'Settings',
    title: 'E-mail',
    lead: 'One SMTP account for every e-mail of the CMS and its plugins. A plugin can use its own SMTP account instead.',
    cmsTitle: 'CMS SMTP',
    effective: 'In use: {source}',
    sourceDatabase: 'the settings below',
    sourceEnvironment: 'the server configuration (SMTP_HOST {host})',
    sourceLog: 'none — e-mails are only written to the log',
    emptyHelp:
      'Leave the host empty to use the server configuration (SMTP_* variables).',
    host: 'SMTP host',
    port: 'Port',
    security: 'Encryption',
    securityNone: 'STARTTLS / none',
    securityTls: 'SSL/TLS',
    username: 'User name',
    password: 'Password',
    passwordKeep: 'Saved — leave empty to keep it',
    removePassword: 'Remove the saved password',
    fromName: 'Sender name',
    fromAddress: 'Sender address',
    fromOptional: 'Empty = the CMS sender',
    replyTo: 'Reply-to address (optional)',
    save: 'Save',
    saved: 'E-mail settings saved',
    testTitle: 'Send a test e-mail',
    testTo: 'Recipient',
    testSend: 'Send test',
    testSent: 'Test e-mail sent ({account})',
    testLogged:
      'No SMTP configured: the test e-mail was only written to the log',
    testFailed: 'Sending failed: {error}',
    pluginsTitle: 'Plugin SMTP accounts',
    pluginsLead:
      'Plugins send through the CMS SMTP unless they have their own account here.',
    plugin: 'Plugin',
    account: 'Account',
    usesCms: 'CMS SMTP',
    ownAccount: 'Own: {host}',
    ownDisabled: 'Own (off): {host}',
    configure: 'Own SMTP',
    edit: 'Edit',
    remove: 'Remove',
    removeConfirm:
      'Remove the SMTP account of {plugin}? It will send through the CMS SMTP again.',
    removed: 'Plugin SMTP account removed',
    pluginDialog: 'SMTP account for {plugin}',
    enabled: 'Use this account for the plugin’s e-mails',
    noPlugins: 'No plugins installed',
    deliveriesTitle: 'Recent e-mails',
    deliveriesEmpty: 'No e-mails sent yet',
    time: 'Time',
    source: 'Sender',
    to: 'To',
    subject: 'Subject',
    status: 'Status',
    statusSENT: 'Sent',
    statusFAILED: 'Failed',
    statusLOGGED: 'Logged only',
    accountplugin: 'plugin SMTP',
    accountcms: 'CMS SMTP',
    accountenvironment: 'server SMTP',
    accountlog: 'log',
    deliveriesSearch: 'Címzett vagy tárgy',
  },
  notifications: {
    title: 'Értesítések',
    unseen: '{count} új',
    empty: 'Még nincs értesítés.',
    markAllRead: 'Összes megjelölése olvasottként',
    dismiss: 'Elvetés',
    soundOn: 'Értesítési hang bekapcsolása',
    soundOff: 'Értesítési hang kikapcsolása',
    sources: {
      content: 'Tartalom',
      admin: 'Adminisztrátor',
      identity: 'Fiókok',
      media: 'Média',
      plugins: 'Bővítmények',
    },
  },
  shell: {
    mainNavigation: 'Főmenü',
    home: 'GX-CMS kezdőlap',
    noRole: 'Nincs szerepkör',
    lightTheme: 'Váltás világos témára',
    darkTheme: 'Váltás sötét témára',
    signOut: 'Kijelentkezés',
    openNavigation: 'Menü megnyitása',
    filterMenu: 'Menü szűrése',
    noMenuMatches: 'Nincs találat',
    expandAll: 'Minden csoport kibontása',
    collapseAll: 'Minden csoport összecsukása',
    resizeNavigation:
      'Navigáció szélességének módosítása: húzza, vagy használja a nyílbillentyűket; dupla kattintás vagy Enter visszaállítja',
    collapseNavigation: 'Navigáció összecsukása ikonokra',
    expandNavigation: 'Navigáció kibontása',
    language: 'Nyelv',
    accessDenied: 'Hozzáférés megtagadva',
    accessDeniedText:
      'Nincs jogosultsága az oldal megtekintéséhez. Kérjen hozzáférést egy adminisztrátortól.',
    notFound: 'Az oldal nem található',
    notFoundText: 'A keresett oldal nem létezik.',
  },
  fields: {
    invalidJson: 'Érvénytelen JSON',
    missingFile: 'Hiányzó fájl',
    addMedia: 'Média hozzáadása',
    chooseMedia: 'Média kiválasztása',
    missingEntry: 'Hiányzó bejegyzés',
    unlink: 'Kapcsolat bontása',
    linkMore: 'További kapcsolása',
    linkEntry: 'Bejegyzés kapcsolása',
    removeItem: 'Elem eltávolítása',
    addItem: 'Elem hozzáadása',
    linkEntries: 'Bejegyzések kapcsolása',
    link: 'Kapcsolás',
    allAllowedTypes: 'Minden engedélyezett típus',
    noMatchingEntries: 'Nincs találat',
  },
  confirm: {
    stillInUse: 'Még használatban van',
    andMore: '…és még {count}',
    deleteAnyway: 'Törlés mégis',
    typeToConfirm: 'A megerősítéshez írja be: {text}',
  },
  actor: {
    system: 'Rendszer',
    you: 'Ön',
    service: 'Szolgáltatás · {name}',
    plugin: 'Bővítmény · {name}',
    user: 'Felhasználó {id}',
  },
  status: {
    PUBLISHED: 'közzétéve',
    ACTIVE: 'aktív',
    ENABLED: 'engedélyezve',
    READY: 'kész',
    SUCCESS: 'sikeres',
    HEALTHY: 'rendben',
    DRAFT: 'piszkozat',
    INSTALLED: 'telepítve',
    IN_REVIEW: 'ellenőrzés alatt',
    SCHEDULED: 'ütemezve',
    PROCESSING: 'feldolgozás alatt',
    UPLOADING: 'feltöltés alatt',
    INVITED: 'meghívva',
    DISCOVERED: 'felfedezve',
    ARCHIVED: 'archiválva',
    DISABLED: 'letiltva',
    DELETED: 'törölve',
    UNKNOWN: 'ismeretlen',
    FAILED: 'sikertelen',
    FAILURE: 'hiba',
    LOCKED: 'zárolva',
    UNHEALTHY: 'hibás',
    PENDING: 'függőben',
  },
  auth: {
    hero: 'Tartalom, {em}',
    heroEm: 'kézben tartva.',
    sub: 'GX-CMS — strukturált tartalom, verziók és közzététel minden csatornára.',
    welcome: 'Üdvözöljük újra',
    signIn: 'Bejelentkezés',
    failed: 'A bejelentkezés sikertelen',
  },
  dashboard: {
    morning: 'Jó reggelt',
    afternoon: 'Jó napot',
    evening: 'Jó estét',
    lead: 'Mi történik a tartalmaival.',
    newEntry: 'Új bejegyzés',
    entries: 'Bejegyzések',
    published: 'Közzétéve',
    drafts: 'Piszkozatok',
    inReview: 'Ellenőrzés alatt',
    scheduled: 'Ütemezve',
    recent: 'Legutóbb szerkesztett',
    viewAll: 'Összes',
    noContent: 'Még nincs tartalom',
    noContentText: 'Hozza létre az első bejegyzést, és itt megjelenik.',
    awaitingReview: 'Ellenőrzésre vár',
    nothingReview: 'Semmi sem vár ellenőrzésre.',
    noScheduled: 'Nincs ütemezett közzététel.',
    fromPlugins: 'A bővítményekből',
    byLanguage: 'Bejegyzések nyelvenként',
  },
  entries: {
    drafts: 'Piszkozatok',
    inReview: 'Ellenőrzés alatt',
    scheduled: 'Ütemezve',
    published: 'Közzétéve',
    archived: 'Archiválva',
    liveIn: 'Élő ezen a nyelven: {language}',
    draftIn: 'Piszkozat ezen a nyelven: {language} (nincs közzétéve)',
    createEntry: 'Bejegyzés létrehozása',
    noActiveTypes: 'Nincs aktív tartalomtípus',
    noActiveTypesText:
      'Bejegyzések létrehozása előtt aktiváljon egy tartalomtípust.',
    deleteCount: {
      one: 'Törli a(z) {count} bejegyzést?',
      other: 'Törli a(z) {count} bejegyzést?',
    },
    deleteText:
      'A kijelölt bejegyzések és verzióelőzményeik véglegesen törlődnek. A közzétett oldalak eltűnnek a webhelyről. Ez nem vonható vissza.',
    stillReferenced: 'Néhány bejegyzésre még hivatkoznak',
    referencedText: {
      one: '{count} bejegyzésre más bejegyzések hivatkoznak. Mégis törli, és eltávolítja ezeket a hivatkozásokat?',
      other:
        '{count} bejegyzésre más bejegyzések hivatkoznak. Mégis törli, és eltávolítja ezeket a hivatkozásokat?',
    },
    deleted: {
      one: '{count} bejegyzés törölve',
      other: '{count} bejegyzés törölve',
    },
    deleteFailed: {
      one: '{count} bejegyzést nem sikerült törölni.',
      other: '{count} bejegyzést nem sikerült törölni.',
    },
    allEntries: 'Összes bejegyzés',
    lead: 'Piszkozatok, ellenőrzések, ütemezett és közzétett tartalmak minden típusból.',
    deleteN: '{count} törlése',
    searchPlaceholder: 'Cím vagy slug',
    contentType: 'Tartalomtípus',
    allTypes: 'Minden típus',
    nothingMatches: 'Nincs találat',
    noEntries: 'Még nincsenek bejegyzések',
    createAn: 'Bejegyzés létrehozása',
    tryFilter: 'Próbáljon másik szűrőt.',
    noEntriesText:
      'Az Ön által létrehozott bejegyzések itt jelennek meg a munkafolyamat-állapotukkal.',
    selectAll: 'Az oldal összes törölhető bejegyzésének kijelölése',
    title: 'Cím',
    live: 'Élő',
    onlyOwn: 'Csak a saját bejegyzéseit törölheti',
    changes: 'Változások',
  },
  editor: {
    scheduleTitle: 'Közzététel ütemezése',
    schedule: 'Ütemezés',
    scheduleText:
      'Az aktuális piszkozatverzió a megadott időpontban automatikusan megjelenik. A bejegyzés későbbi szerkesztése nem változtat azon, mi jelenik meg.',
    publishAt: 'Közzététel ideje',
    restoredPublished: 'A(z) {n}. verzió visszaállítva és közzétéve',
    restoredDraft: 'A(z) {n}. verzió visszaállítva új piszkozatként',
    versionN: '{n}. verzió',
    restorePublish: 'Visszaállítás és közzététel',
    restoreDraft: 'Visszaállítás piszkozatként',
    summary: 'Összefoglaló',
    schema: 'Séma',
    restoreNote:
      'A visszaállítás új verziót hoz létre ebből az állapotból. Az előzmények sosem íródnak át.',
    removeLanguageTitle: 'Eltávolítja ezt a nyelvet: {language}?',
    removeLanguageText:
      'A fordításai mentéskor kikerülnek a bejegyzésből, és a következő közzététel után az oldal ezen a nyelven már nem érhető el. A korábbi verziók megőrzik őket.',
    discardTitle: 'Elveti a módosításokat?',
    discardText: 'Nem mentett módosításai vannak. Kilép mentés nélkül?',
    discard: 'Elvetés',
    created: 'Bejegyzés létrehozva',
    savedAs: 'Mentve {n}. verzióként',
    conflict:
      'Valaki más mentette ezt a bejegyzést. Töltse újra a változások megtekintéséhez.',
    chooseType: 'Válasszon tartalomtípust a bejegyzés létrehozásához.',
    createDraft: 'Piszkozat létrehozása',
    saveDraft: 'Piszkozat mentése',
    saved: 'Mentve',
    fixFields: 'Javítsa a kiemelt mezőket',
    actionFailed: 'A műveletet nem sikerült végrehajtani',
    editingLanguage: 'Szerkesztés nyelve',
    contentLanguage: 'Tartalom nyelve',
    languagesHelp:
      'Azok a nyelvek, amelyeken a bejegyzés létezik. A webhely csak ezeken a nyelveken mutatja; a közzétételhez minden kötelező mezőt minden nyelven ki kell tölteni.',
    publishing: 'Közzététel',
    liveChanges: 'Élő · változások függőben',
    draft: 'Piszkozat',
    notPublished: 'Nincs közzétéve',
    publishedToast: 'Közzétéve',
    savePublish: 'Mentés és közzététel',
    republish: 'Újbóli közzététel',
    publish: 'Közzététel',
    submittedToast: 'Ellenőrzésre beküldve',
    submit: 'Beküldés ellenőrzésre',
    returnedToast: 'Visszaküldve piszkozatba',
    returnToDraft: 'Vissza piszkozatba',
    saveFirst: 'Előbb mentsen',
    scheduleCancelled: 'Ütemezés törölve',
    cancelSchedule: 'Ütemezés törlése',
    unpublishTitle: 'Visszavonja a közzétételt?',
    unpublishText:
      'Azonnal eltűnik a tartalomszolgáltató API-ból. A piszkozat megmarad.',
    unpublish: 'Közzététel visszavonása',
    unpublishedToast: 'Közzététel visszavonva',
    preview: 'Előnézet',
    archiveTitle: 'Archiválja a bejegyzést?',
    archiveText:
      'Az archiválás visszavonja a közzétételt, és elrejti a bejegyzést az alapnézetekből.',
    archive: 'Archiválás',
    archivedToast: 'Archiválva',
    restoredToast: 'Visszaállítva',
    restore: 'Visszaállítás',
    deleteTitle: 'Törli a bejegyzést?',
    deleteText: '„{title}” és teljes verzióelőzménye véglegesen törlődik.',
    deletePublic: 'A nyilvános oldala eltűnik a webhelyről.',
    cannotUndo: 'Ez nem vonható vissza.',
    deleted: 'Bejegyzés törölve',
    slug: 'Slug',
    slugGenerated: 'A címből generálva',
    slugHelp: 'URL-ekben és a tartalomszolgáltató API-ban használatos.',
    fromTitle: 'A címből',
    changeNote: 'Módosítási megjegyzés',
    changeNotePlaceholder: 'Mi változott? (nem kötelező)',
    liveUrl: 'Nyilvános URL',
    noPublicPage:
      'Nincs nyilvános oldal (hiányzó slug vagy kategória, vagy a típus nem nyilvános)',
    history: 'Előzmények',
    liveLower: 'élő',
    draftSaved: 'Piszkozat mentve',
    noHistory: 'Még nincsenek előzmények.',
    scheduledFor: 'Ütemezve: {time}',
  },
  plugins: {
    plugin: 'Bővítmény',
    continue: 'Tovább',
    frameNoValues: 'Ez a bővítés nem módosíthat mezőértékeket.',
    frameAdminPaths: 'Csak adminisztrációs útvonalak nyithatók meg.',
    frameNoMedia: "Ez a bővítmény nem kapott 'media.asset.read' jogosultságot.",
    requestFailed: 'A kérés sikertelen',
    isolated: 'Egy bővítmény jeleníti meg elszigetelt keretben',
    extensionUnavailable: 'A bővítés nem érhető el',
    extensionUnavailableText:
      'Ez a bővítményoldal nincs regisztrálva, vagy a bővítmény le van tiltva.',
  },
  types: {
    titleField: 'Cím',
    createdToast: '„{name}” tartalomtípus létrehozva',
    newType: 'Új tartalomtípus',
    namePlaceholder: 'Cikk',
    apiKey: 'API-kulcs',
    apiKeyHelp:
      'API-útvonalakban használatos, pl. /api/v1/delivery/article. Később nem módosítható.',
    titleAdded: 'Kezdésként egy kötelező „Cím” mező kerül hozzáadásra.',
    kicker: 'Tartalommodellezés',
    lead: 'Határozza meg a tartalmai szerkezetét. A bejegyzéseket minden mentéskor és közzétételkor ezekhez a sémákhoz ellenőrizzük.',
    none: 'Még nincsenek tartalomtípusok',
    createFirst: 'Az első típus létrehozása',
    noneText:
      'A tartalomtípusok leírják, hogyan épül fel egy cikk, egy oldal vagy egy termék.',
    fields: 'Mezők',
    one: 'Tartalomtípus',
    searchPlaceholder: 'Név, API-kulcs vagy leírás',
  },
  fieldTypes: {
    TEXT: {
      label: 'Szöveg',
      description: 'Rövid szöveg, például cím vagy név',
    },
    RICH_TEXT: {
      label: 'Formázott szöveg',
      description: 'Hosszú, formázott szöveg (Markdown)',
    },
    NUMBER: {
      label: 'Szám',
      description: 'Egész vagy tizedes szám, opcionális korlátokkal',
    },
    BOOLEAN: { label: 'Igen/nem', description: 'Igen/nem kapcsoló' },
    DATE: { label: 'Dátum', description: 'Naptári dátum' },
    DATETIME: { label: 'Dátum és idő', description: 'Dátum időponttal' },
    JSON: { label: 'JSON', description: 'Tetszőleges strukturált adat' },
    MEDIA: {
      label: 'Média',
      description: 'Képek, videók vagy dokumentumok a médiatárból',
    },
    RELATION: {
      label: 'Kapcsolat',
      description: 'Hivatkozás más bejegyzésekre',
    },
    ENUM: {
      label: 'Választás',
      description: 'Egy érték egy rögzített listából',
    },
    URL: { label: 'URL', description: 'Webcím' },
  },
  builder: {
    required: 'kötelező',
    localized: 'fordítható',
    list: 'lista',
    images: 'Képek',
    video: 'Videó',
    audio: 'Hang',
    defaultInvalid:
      'Az alapértéknek érvényes JSON-nak kell lennie (pl. "szöveg", 42, true vagy ["a"]).',
    editField: 'Mező szerkesztése',
    addField: 'Mező hozzáadása',
    saveField: 'Mező mentése',
    locked:
      'Ehhez a típushoz már vannak bejegyzések. A kulcs, a lista és a fordítás beállításai zárolva vannak; csak kompatibilis típusváltás lehetséges.',
    label: 'Címke',
    keyHelp: 'A tulajdonság neve az API-adatokban.',
    requiredLabel: 'Kötelező',
    localizedLabel: 'Fordítható (nyelvenként egy érték)',
    multiple: 'Több érték',
    helpText: 'Súgószöveg',
    helpTextHelp: 'A mező alatt jelenik meg a szerkesztőknek.',
    validation: 'Ellenőrzés',
    minLength: 'Minimális hossz',
    maxLength: 'Maximális hossz',
    minimum: 'Minimum',
    maximum: 'Maximum',
    pattern: 'Minta (reguláris kifejezés)',
    integer: 'Csak egész számok',
    minItems: 'Minimális elemszám',
    maxItems: 'Maximális elemszám',
    options: 'Lehetőségek',
    optionsHelp: 'Soronként egy lehetőség.',
    allowedTypes: 'Engedélyezett tartalomtípusok',
    anyType: 'Hagyja üresen, ha bármely típus megengedett.',
    allowedMedia: 'Engedélyezett média',
    anyMedia: 'Hagyja üresen, ha bármely médiatípus megengedett.',
    defaultValue: 'Alapérték (JSON)',
    defaultHelp: 'Új bejegyzésekre érvényes. Példák: "Cím nélkül", 0, true.',
    settingsSaved: 'Beállítások mentve',
    keysPermanent: 'A kulcsok véglegesek.',
    titleField: 'Címmező',
    firstText: 'Első szövegmező',
    titleFieldHelp: 'A listákban ez jelenik meg a bejegyzés neveként.',
    slugFrom: 'Slug generálása ebből',
    noGenerate: 'Ne generáljon',
    slugRequired: 'Közzétételhez kötelező a slug',
    previewTemplate: 'Előnézeti URL-sablon',
    previewHelp:
      'Helyőrzők: {slug}, {id}, {token}. Az „Előnézet” művelet használja.',
    publicUrls: 'Nyilvános URL-ek',
    reserved:
      'A(z) {prefix} előtagot ez foglalja: {owner}. Módosítása kiviszi ezeket az oldalakat a bővítmény URL-teréből.',
    urlPrefix: 'URL-előtag',
    urlPrefixHelp:
      'A típus első URL-szegmense. Egyedinek kell lennie; a rendszerszavak és a nyelvkódok foglaltak.',
    categoryFrom: 'Kategóriaszegmens forrása',
    noCategory: 'Nincs kategóriaszegmens',
    choice: 'választás',
    linkedSlug: 'kapcsolt bejegyzés slugja',
    categoryHelp:
      'Egyetlen választómező vagy hivatkozás egy kategória-bejegyzésre.',
    publicPages: 'A bejegyzéseknek van nyilvános oldaluk',
    servedAt:
      'Az oldalak itt érhetők el: {path}, minden nyelven, amelyen a bejegyzés létezik. Slug nélküli bejegyzésnek nincs nyilvános oldala. Az előtag módosítása után a régi URL-ek végleges (308) átirányítással működnek.',
    servedAtCategory:
      'Az oldalak itt érhetők el: {path}, minden nyelven, amelyen a bejegyzés létezik. Slug vagy kategória nélküli bejegyzésnek nincs nyilvános oldala. Az előtag vagy kategória módosítása után a régi URL-ek végleges (308) átirányítással működnek.',
    widgets: 'Mezőmodulok (bővítmények)',
    defaultEditor: 'Alapértelmezett szerkesztő',
    saveSettings: 'Beállítások mentése',
    fieldSaved: 'Mező mentve',
    viewEntries: 'Bejegyzések megtekintése',
    activated: 'Tartalomtípus aktiválva',
    activate: 'Aktiválás',
    archiveTitle: 'Archiválja a tartalomtípust?',
    archiveText:
      'Nem hozhatók létre új bejegyzések, és a típus tartalmainak kiszolgálása leáll. A meglévő bejegyzések megmaradnak.',
    deleteTitle: 'Törli a tartalomtípust?',
    deleteWithEntries: {
      one: '„{name}” és {count} bejegyzése (minden verzió és nyelv) véglegesen törlődik. A közzétett oldalak eltűnnek a webhelyről. Ez nem vonható vissza.',
      other:
        '„{name}” és mind a(z) {count} bejegyzése (minden verzió és nyelv) véglegesen törlődik. A közzétett oldalak eltűnnek a webhelyről. Ez nem vonható vissza.',
    },
    deleteEmpty: '„{name}” véglegesen törlődik. Ez nem vonható vissza.',
    deleted: 'Tartalomtípus törölve',
    schemaVersion: 'Sémaverzió: {n}',
    noFields: 'Nincsenek mezők',
    noFieldsText: 'Adjon hozzá mezőket a tartalomtípus leírásához.',
    titleTag: 'CÍM',
    widget: 'modul: {name}',
    moveUp: 'Feljebb',
    moveDown: 'Lejjebb',
    editX: '{name} szerkesztése',
    removeX: '{name} eltávolítása',
    removeFieldTitle: 'Eltávolítja a mezőt?',
    removeFieldUsed:
      '„{name}” eltűnik a szerkesztőből és a kiszolgálásból. Az értékek a korábbi verziókban megmaradnak.',
    removeFieldEmpty: '„{name}” eltávolításra kerül.',
    fieldRemoved: 'Mező eltávolítva',
    namesTitle: 'Név a webhelyen',
    namesHelp:
      'Hogyan nevezzük ezt a típust az egyes nyelveken (menü, címkék). Üresen: a fenti név.',
  },
  media: {
    saved: 'Médiaadatok mentve',
    details: 'Médiaadatok',
    deleteTitle: 'Törli a fájlt?',
    deleteText:
      '„{name}” törlődik a tárhelyről, és sehol sem töltődik be többé. Ez nem vonható vissza.',
    deleted: 'Fájl törölve',
    file: 'Fájl',
    size: 'Méret',
    uploaded: 'Feltöltve',
    checksum: 'Ellenőrzőösszeg',
    altText: 'Helyettesítő szöveg',
    altHelp:
      'Írja le a képet képernyőolvasók számára. Az akadálymentes tartalomhoz szükséges.',
    visibility: 'Láthatóság',
    public: 'Nyilvános — állandó URL, gyorsítótárazható',
    private: 'Privát — csak rövid életű, aláírt hivatkozások',
    linkCopied: 'Hivatkozás másolva',
    copyLink: 'Hivatkozás másolása',
    download: 'Letöltés',
    kicker: 'Médiatár',
    lead: 'Képek, videók, hangok és dokumentumok. A fájlok objektumtárban vannak, és aláírásuk alapján ellenőrizzük őket.',
    searchPlaceholder: 'Fájlnév, cím vagy helyettesítő szöveg',
    documents: 'Dokumentumok',
    none: 'Még nincs média',
    noneText: 'Töltsön fel fájlokat, hogy a tartalmaiban használhassa őket.',
    openX: '{name} megnyitása',
    missingAlt: 'Hiányzó helyettesítő szöveg',
    noAlt: 'NINCS ALT',
    selectMedia: 'Média kiválasztása',
    selectFile: 'Fájl kiválasztása',
    useSelected: 'Kijelöltek használata',
    pickerSearch: 'Keresés fájlnév vagy helyettesítő szöveg alapján',
    searchMedia: 'Keresés a médiában',
    noneFound: 'Nincs média',
    uploadedX: 'Feltöltve: {name}',
    drop: '{strong} vagy kattintson a tallózáshoz',
    dropStrong: 'Húzza ide a fájlokat',
    dropHelp:
      'Képek, videók, hangok és PDF. A fájltípust feltöltéskor ellenőrizzük.',
  },
  pluginList: {
    kicker: 'Bővítés',
    lead: 'A bővítmények nem megbízhatók, amíg egy adminisztrátor át nem nézi a jogosultságaikat, majd telepíti és engedélyezi őket. A CMS magjától elszigetelten futnak.',
    invalid: '{count} csomag ellenőrzése sikertelen: {paths}',
    scanned: 'Tár átvizsgálva: {count} csomag',
    scan: 'Tár átvizsgálása',
    none: 'Nem található bővítmény',
    noneText:
      'Tegye a bővítménycsomagokat (cms-plugin.json fájllal) a bővítménytár könyvtárába, majd vizsgálja át a tárat.',
    capabilities: 'Jogosultságok',
    health: 'Állapot',
    update: 'Frissítés: {version}',
    signed: 'Aláírt',
    badSignature: 'Hibás aláírás',
    packageMissing: 'Hiányzó csomag',
    granted: '{granted} / {requested} megadva',
    noSettings: 'Ennek a bővítménynek nincsenek beállításai.',
    saveConfig: 'Konfiguráció mentése',
    updates: 'Frissítés elérhető',
    searchPlaceholder: 'Név, kulcs vagy kiadó',
  },
  pluginDetail: {
    features: 'Funkciók',
    featuresText:
      'A funkciókapcsolók mindenki számára be- vagy kikapcsolják a bővítmény egyes részeit. Csak engedélyezett bővítménynél hatnak, és sosem adnak jogosultságot.',
    installFirst: 'Telepítse a bővítményt a funkciói kezeléséhez.',
    turnedOn: '{key} bekapcsolva',
    turnedOff: '{key} kikapcsolva',
    inactive: 'inaktív, amíg a bővítmény le van tiltva',
    changed: 'módosítva: {time}',
    installed: '{name} telepítve',
    updatedTo: '{name} frissítve erre: {version}',
    installX: '{name} telepítése',
    updateX: '{name} frissítése',
    approveInstall: 'Jóváhagyás és telepítés',
    approveUpdate: 'Jóváhagyás és frissítés',
    installFailed: 'A bővítményt nem sikerült telepíteni',
    unsigned:
      'Ezt a csomagot nem írta alá megbízható kiadó. Csak olyan bővítményt telepítsen, amelynek forráskódját átnézte.',
    requests:
      '{name} {version} az alábbi jogosultságokat kéri. Vegye ki a pipát mindenből, amit nem szeretne megadni — a bővítmény csak azt használhatja, amit jóváhagy, és a jogosultságokat bármikor visszavonhatja.',
    granted: 'Megadva',
    migrationsWillRun:
      '{count} migráció fut az elszigetelt bővítmény-futtatókörnyezetben, és a naplóba kerül.',
    uninstallX: '{name} eltávolítása',
    uninstalled: 'Bővítmény eltávolítva',
    uninstall: 'Eltávolítás',
    uninstallText:
      'Minden jogosultság visszavonásra kerül. A bővítmény által a CMS API-n keresztül létrehozott tartalmak (például tartalomtípusok) megmaradnak.',
    pluginData: 'Bővítményadatok',
    keepData:
      'Bővítményadatok és konfiguráció megtartása (későbbi újratelepítéshez)',
    deleteData: 'Bővítményadatok és konfiguráció végleges törlése',
    typeKey: 'A megerősítéshez írja be: {key}',
    disableX: '{name} letiltása',
    disabledToast: 'Bővítmény letiltva',
    disable: 'Letiltás',
    disableText:
      'Az eseményfeliratkozások, feladatok és adminisztrációs bővítések azonnal leállnak. A bővítményadatok megmaradnak.',
    reason: 'Indoklás (nem kötelező)',
    incident: 'Biztonsági incidens — automatikus újraengedélyezés tiltása',
    install: 'Telepítés',
    updateTo: 'Frissítés erre: {version}',
    enabledToast: '{name} engedélyezve',
    enable: 'Engedélyezés',
    deleteTitle: 'Törli a bővítményrekordot?',
    deleteGone:
      '„{name}” rekordja (a csomagja már nincs meg) és minden megőrzött bővítményadat véglegesen törlődik.',
    deleteRegistry:
      '„{name}” rekordja és minden megőrzött bővítményadat véglegesen törlődik. A csomag még a tárban van, így a következő átvizsgáláskor újra felfedezettként jelenik meg.',
    deleted: 'Bővítmény törölve',
    lastError: 'Utolsó hiba',
    notCompatible: 'Nem kompatibilis',
    overview: 'Áttekintés',
    configuration: 'Konfiguráció',
    migrations: 'Migrációk',
    package: 'Csomag',
    installedLabel: 'Telepített',
    notInstalled: 'Nincs telepítve',
    available: 'Elérhető',
    publisher: 'Kiadó',
    license: 'Licenc',
    defaultLanguage: '{language} (alapértelmezett)',
    languagesHelp:
      'A bővítmény saját képernyői az adminisztrációs nyelvet használják, ha szerepel itt, egyébként az alapértelmezett nyelvüket.',
    signature: 'Aláírás',
    integrity: 'Sértetlenség',
    homepage: 'Weboldal',
    backendService: 'Háttérszolgáltatás',
    bound: 'csatlakoztatva',
    notBound: 'nincs csatlakoztatva',
    permissionsAdded: 'Hozzáadott jogosultságok',
    defaultRoles: 'alapértelmezés: adminisztrátor, {roles}',
    runtime: 'Futtatás',
    lastCheck: 'Utolsó ellenőrzés',
    backend: 'Háttér',
    adminUi: 'Adminisztrációs felület',
    events: 'Események',
    jobs: 'Feladatok',
    every: '{id} ({seconds} mp-enként)',
    dependencies: 'Függőségek',
    optional: 'opcionális',
    notInstalledLower: 'nincs telepítve',
    missing: 'hiányzik',
    grants: 'Megadott jogosultságok',
    grantsText:
      'Alapértelmezés szerint tiltva: a kért jogosultság a megadásig nem hat. A visszavonás másodperceken belül érvényes, a futó bővítményfolyamatokra is.',
    grantedAt: 'Megadva: {time}',
    noLongerRequested: 'Már nem kéri',
    notGranted: 'Nincs megadva',
    revokedToast: 'Jogosultság visszavonva',
    grantedToast: 'Jogosultság megadva',
    revoke: 'Visszavonás',
    grant: 'Megadás',
    configSaved: 'Konfiguráció mentve',
    migrationsDone: 'Migrációk befejezve',
    retry: 'Újra',
    noMigrations: 'Nincs megadott migráció.',
    migration: 'Migráció',
    applied: 'Alkalmazva',
  },
  users: {
    permissionsCount: '{count} jogosultság',
    created: 'Felhasználó létrehozva',
    invite: 'Felhasználó meghívása',
    createUser: 'Felhasználó létrehozása',
    initialPassword: 'Kezdő jelszó',
    passwordHelp:
      'Legalább 12 karakter, a következők közül hárommal: kisbetű, nagybetű, számjegy, írásjel. Biztonságosan adja át.',
    updated: 'Felhasználó frissítve',
    deleteTitle: 'Törli a felhasználót?',
    deleteText:
      '{name} ({email}) mindenhol kijelentkezik, és minden munkamenetével és szerepkör-hozzárendelésével együtt véglegesen törlődik. Az általa létrehozott tartalmak megmaradnak. Ez nem vonható vissza.',
    deleted: 'Felhasználó törölve',
    disableTitle: 'Letiltja a felhasználót?',
    disableText:
      '{name} mindenhol kijelentkezik, és amíg újra nem engedélyezik, nem tud bejelentkezni.',
    reenabled: 'Felhasználó újra engedélyezve',
    unlock: 'Feloldás',
    lastSignIn: 'Utolsó bejelentkezés',
    resetPassword: 'Jelszó visszaállítása',
    newPassword: 'Új jelszó',
    resetDone: 'Jelszó visszaállítva; minden munkamenet kijelentkeztetve',
    reset: 'Visszaállítás',
    lead: 'Akik bejelentkezhetnek a GX-CMS-be. A hozzáférést szerepkörök adják.',
    add: 'Felhasználó hozzáadása',
    searchPlaceholder: 'Név vagy e-mail',
    anyStatus: 'Bármely állapot',
    none: 'Nem található felhasználó',
  },
  roles: {
    audit: 'Naplózás',
    newRole: 'Új szerepkör',
    lead: 'A szerepkörök jogosultságokat fognak össze. Minden API minden kérésnél a szerveren ellenőrzi a jogosultságokat; a változások másodperceken belül érvényesek.',
    users: { one: '{count} felhasználó', other: '{count} felhasználó' },
    system: 'Rendszer',
    deleteTitle: 'Törli a szerepkört?',
    deleteText: '{count} felhasználó elveszíti a(z) „{name}” jogosultságait.',
    saved: 'Jogosultságok mentve',
    adminAll:
      'Az adminisztrátor szerepkör mindig minden jogosultsággal rendelkezik.',
    created: 'Szerepkör létrehozva — most válassza ki a jogosultságait',
  },
  permissions: {
    'user.read': 'Felhasználók és szerepkörök megtekintése',
    'user.manage':
      'Felhasználók létrehozása, módosítása és letiltása; szerepkörök kezelése',
    'user.delete': 'Felhasználói fiókok végleges törlése',
    'content.type.read': 'Tartalomtípusok és mezők megtekintése',
    'content.type.manage': 'Tartalomtípusok és mezők létrehozása és módosítása',
    'content.entry.read': 'Bejegyzések, piszkozatok és verziók megtekintése',
    'content.entry.create': 'Bejegyzések létrehozása',
    'content.entry.update':
      'Piszkozatok szerkesztése, beküldése ellenőrzésre és bejegyzések archiválása',
    'content.entry.publish':
      'Bejegyzések közzététele, visszavonása és ütemezése',
    'content.entry.rollback': 'Bejegyzések visszaállítása korábbi verzióra',
    'content.entry.delete': 'Bármely bejegyzés végleges törlése',
    'content.entry.delete.own': 'A saját bejegyzések végleges törlése',
    'content.type.delete': 'Tartalomtípusok törlése az összes bejegyzésükkel',
    'media.read': 'A médiatár megtekintése',
    'media.upload': 'Média feltöltése és szerkesztése',
    'media.delete': 'Bármely médiafájl törlése',
    'media.delete.own': 'A saját feltöltésű média törlése',
    'plugin.read': 'Bővítmények megtekintése',
    'plugin.install':
      'Bővítmények felfedezése, telepítése és eltávolítása; jogosultságok megadása',
    'plugin.enable': 'Bővítmények engedélyezése és letiltása',
    'plugin.configure': 'Bővítmények konfigurálása',
    'plugin.delete': 'Bővítményrekordok eltávolítása a tárból',
    'plugin.feature.manage': 'Bővítmények funkciókapcsolóinak kezelése',
    'audit.read': 'Keresés a naplóban',
    'mail.settings.manage':
      'Manage the e-mail (SMTP) settings of the CMS and plugins',
    'mail.send': 'Send e-mail through the CMS mail settings (plugins)',
    'backup.export':
      'Az összes adat és médiafájl mentésének letöltése, a felhasználókkal és a beállításokkal együtt',
    'backup.import': 'Az összes adat és médiafájl lecserélése egy mentésre',
    'site.settings.manage':
      'A weboldal nevének, leírásának, nyelveinek és elérhetőségeinek szerkesztése',
  },
  audit: {
    lead: 'Hozzáfűzés-alapú napló minden szolgáltatás biztonsági és üzleti szempontból fontos eseményeiről.',
    action: 'Művelet',
    actionPlaceholder: 'pl. content.entry.published',
    resource: 'Erőforrás',
    any: 'Bármely',
    outcome: 'Eredmény',
    from: 'Ettől',
    to: 'Eddig',
    none: 'Nincsenek események',
    noneText: 'Semmi sem felel meg a szűrőknek.',
    time: 'Időpont',
    actor: 'Végrehajtó',
    event: 'Naplóesemény',
    source: 'Forrás',
    correlation: 'Korreláció',
    eventId: 'Eseményazonosító',
    metadata: 'Metaadatok',
  },
  settings: {
    profileUpdated: 'Profil frissítve',
    mismatch: 'Az új jelszavak nem egyeznek.',
    passwordChanged:
      'Jelszó módosítva. A többi munkamenet kijelentkeztetésre került.',
    kicker: 'Fiókom',
    profile: 'Profil',
    emailHelp: 'Az e-mail-cím módosításához forduljon egy adminisztrátorhoz.',
    saveProfile: 'Profil mentése',
    currentPassword: 'Jelenlegi jelszó',
    passwordHelp:
      'Legalább 12 karakter, a következők közül hárommal: kisbetű, nagybetű, számjegy, írásjel.',
    confirmPassword: 'Új jelszó megerősítése',
    changePassword: 'Jelszó módosítása',
    appearance: 'Megjelenés',
    design: 'Téma',
    designHelp:
      'Ebben a böngészőben megváltoztatja az admin és a bővítményoldalak megjelenését. A világos vagy sötét módot alább választhatja ki.',
    designs: {
      gxlabs: {
        name: 'GXLabs (alapértelmezett)',
        about: 'Fekete-fehér, cián kiemeléssel',
      },
      apple: { name: 'Apple', about: 'Nyugodt, lekerekített, macOS-stílusú' },
      aurora: { name: 'Aurora', about: 'Ibolya, fukszia és cián' },
      sunset: { name: 'Sunset', about: 'Korall, mandarin és rózsa' },
      lagoon: { name: 'Lagoon', about: 'Kékeszöld, smaragd és égszínkék' },
      neon: { name: 'Neon', about: 'Bíbor és cián, sötét módban a legszebb' },
    },
    theme: 'Téma',
    light: 'Világos',
    dark: 'Sötét',
    system: 'Rendszer szerint',
    languageHelp:
      'Az adminisztrációs felület a webhely nyelvein érhető el. Az Ön nyelvét nem támogató bővítményoldalak az alapértelmezett nyelvüket használják.',
    access: 'Hozzáférés',
    permissions: 'Jogosultságok',
  },
  website: {
    kicker: 'Adminisztráció',
    title: 'Weboldal',
    lead: 'Amit a nyilvános weboldal magáról mutat: a nevét, leírását, nyelveit és elérhetőségeit. A CMS adminisztráció nem használja ezeket a beállításokat.',
    general: 'Általános',
    name: 'A weboldal neve',
    nameHelp: 'A böngészőfülön, a keresési találatokban és a láblécben.',
    descriptionIn: 'Leírás ({language})',
    descriptionHelp:
      'A keresési találatokban jelenik meg, és amikor a weboldal egy oldalát megosztják.',
    languages: 'Nyelvek',
    languagesLabel: 'A weboldal nyelvei',
    languagesHelp:
      'A weboldal csak ezeket kínálja. A szerkesztők továbbra is bármely CMS-nyelven írhatnak tartalmat: az a weboldalon akkor jelenik meg, amikor a nyelvét itt bekapcsolják.',
    defaultLanguage: 'Alapértelmezett nyelv',
    defaultLanguageHelp:
      'Ide érkeznek a látogatók, akik nyelv nélkül nyitják meg a címet.',
    contact: 'Elérhetőség',
    contactLead:
      'Minden oldal kapcsolati sávjában és láblécében. Az üres mezők nem jelennek meg.',
    email: 'E-mail',
    phone: 'Telefon',
    address: 'Cím',
    mapQuery: 'Térkép',
    mapQueryHelp:
      'A minden oldal alján lévő térkép Google Maps keresőszövege, pl. a cégnév és a cím. Üres = nincs térkép.',
    social: 'Közösségi média',
    fonts: 'Betűtípusok',
    adobeFontsKit: 'Adobe Fonts kit azonosító',
    adobeFontsKitHelp:
      'A weboldal betűtípusait tartalmazó kit (engedélyezze a weboldal domainjeit az Adobe Fontsban). Üres = ingyenes helyettesítő betűtípusok.',
    save: 'Mentés',
    saved:
      'A weboldal beállításai elmentve. A weboldal egy percen belül mutatja őket.',
    lastSaved: 'Utoljára mentve: {when}',
    neverSaved: 'Még nincs elmentve.',
  },
  backup: {
    kicker: 'Adminisztráció',
    title: 'Biztonsági mentés',
    lead: 'Töltse le a webhely teljes tartalmát egyetlen ZIP-fájlként, vagy cserélje le egy ilyen fájlra: másolatnak, vagy hogy a webhelyet másik szerverre költöztesse.',
    exportTitle: 'Mentés letöltése',
    exportLead:
      'A ZIP-fájl SQL-ként tartalmazza a CMS minden részének adatait (tartalmak, felhasználók és szerepkörök, beállítások, bővítmények, CRM, webshop, foglalások, üzenetek, auditnapló), valamint az összes médiafájlt.',
    exportSecret:
      'Személyes adatokat, jelszó-hasheket és titkosított titkokat tartalmaz. Őrizze úgy, mint egy jelszót.',
    exportKeys:
      'Az adminban mentett titkokat (SMTP-jelszavak, fizetési kulcsok) a PLUGIN_SECRETS_KEY és a MAIL_SECRETS_KEY szerverkulcs titkosítja. Csak ott olvashatók, ahol ugyanezek a kulcsok vannak beállítva.',
    download: 'Mentés letöltése',
    preparing: 'Előkészítés…',
    downloadStarted:
      'A letöltés elindult. Nagy webhelyeknél ez eltart egy ideig.',
    importTitle: 'Mentés importálása',
    importLead:
      'Töltsön fel egy GX-CMS-sel készült mentést. Mielőtt bármi megváltozna, látni fogja, mit tartalmaz.',
    importReplaces:
      'Az importálás a webhely összes adatát és médiafájlját lecseréli. A felhasználók, jelszavak és szerepkörök a mentésből származnak, így utána a mentésben szereplő fiókkal jelentkezik be.',
    chooseFile: 'ZIP-fájl kiválasztása',
    uploading: 'Feltöltés… {percent}%',
    checking: 'A mentés ellenőrzése…',
    backupOf: 'Mentés innen: {source}',
    unknownSource: 'ismeretlen webhely',
    createdAt: 'Készült: {date}, GX-CMS {version}',
    part: 'Rész',
    rows: 'Rekordok',
    mediaFiles: 'Médiafájlok',
    mediaSummary: '{files} fájl, {size}',
    canImport: 'Ez a mentés importálható.',
    cannotImport: 'Ez a mentés itt nem importálható:',
    notes: 'Jó tudni:',
    replace: 'Összes adat lecserélése…',
    discard: 'Feltöltés elvetése',
    discarded: 'Feltöltés elvetve',
    confirmTitle: 'Lecseréli az összes adatot?',
    confirmMessage:
      'A webhely összes tartalmát, felhasználóját, beállítását és bővítményadatát lecseréli a(z) {date} időpontban készült mentés. Az import végéig megmarad a jelenlegi adatok másolata, és ha az import nem sikerül, visszaáll. A folytatáshoz írja be: {word}.',
    confirmWord: 'CSERE',
    confirmLabel: 'Összes adat lecserélése',
    running: 'Importálás…',
    steps: {
      check: 'Ellenőrzés',
      media: 'Médiafájlok másolása ({count})',
      'safety-copy': 'A jelenlegi adatok másolatának elkészítése',
      database: 'Betöltés: {part}',
      rollback: 'Hiba történt: a korábbi adatok visszaállítása',
      done: 'Kész',
    } as Record<string, string>,
    succeeded:
      'A mentés importálva: {rows} rekord és {files} médiafájl. Jelentkezzen be egy, a mentésben szereplő fiókkal.',
    signIn: 'Bejelentkezés',
    failed: 'Az importálás nem sikerült: {error}',
    rolledBack:
      'A korábbi adatok visszaálltak; az új médiafájlokon kívül semmi sem változott.',
    notRolledBack:
      'Az adatok hiányosak lehetnek. Importálja újra a mentést, vagy egy másikat.',
    statusLost:
      'Az importálás közben kijelentkeztette a rendszer. A folyamat állása alább látható.',
    parts: {
      'identity-service': 'Felhasználók, szerepkörök és e-mail-beállítások',
      'content-service': 'Tartalmak és tartalomtípusok',
      'media-service': 'Médiatár',
      'plugin-service': 'Bővítmények és beállításaik',
      'audit-service': 'Auditnapló',
      'crm-service': 'CRM',
      'webshop-service': 'Webshop',
      'appointments-service': 'Időpontfoglalás',
      'contact-service': 'Kapcsolatfelvételi üzenetek',
      'mobile-app-service': 'Mobilalkalmazás',
    } as Record<string, string>,
    issues: {
      format_unsupported:
        'Újabb GX-CMS-verzióval készült ({version}. mentési formátum).',
      manifest_invalid: 'Ez nem GX-CMS-mentés, vagy a fájl sérült.',
      file_missing: 'A mentés egy része hiányzik ({part}).',
      service_unavailable:
        '{part}: ez a rész nem fut ezen a webhelyen. Először kapcsolja be.',
      service_not_in_backup:
        '{part}: nincs benne a mentésben; a jelenlegi adatai megmaradnak.',
      migrations_differ_older:
        '{part}: a mentés régebbi GX-CMS-verzióval készült. Importálja abba a verzióba, majd frissítsen.',
      migrations_differ_newer:
        '{part}: a mentés újabb GX-CMS-verzióval készült. Előbb frissítse ezt a webhelyet.',
      migrations_differ_different:
        '{part}: a mentés más GX-CMS-verzióval készült.',
      key_differs:
        '{part}: ezen a szerveren másik {key} van beállítva. Az adminban mentett titkok (jelszavak, fizetési kulcsok) az importálás után nem olvashatók; adja meg őket újra, vagy előbb állítsa be ugyanazt a kulcsot.',
    } as Record<string, string>,
  },
  errors: {
    generic: 'Hiba történt.',
    offline: 'A GX-CMS nem érhető el. Ellenőrizze a kapcsolatot.',
    uploadFailed: 'A feltöltés sikertelen',
    uploadNetwork: 'A feltöltés sikertelen: hálózati hiba.',
  },
}
